import { DisplayMode } from '../enums/display-mode.enum';
import { FontSizes } from '../enums/font-sizes.enum';

export interface UserSettings {
    displayMode: DisplayMode;
    fontSize: FontSizes;
}

export const defaultUserSettings: UserSettings = {
    displayMode: DisplayMode.lightMode,
    fontSize: FontSizes.medium,
};

export function validateUserSettings(settings: Partial<UserSettings>): UserSettings {
    return {
        displayMode: Object.values(DisplayMode).includes(settings.displayMode!) ? settings.displayMode! : defaultUserSettings.displayMode,
        fontSize: Object.values(FontSizes).includes(settings.fontSize!) ? settings.fontSize! : defaultUserSettings.fontSize,
    };
}
